import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { IndexAdminModel } from 'digiteq-ai-portal-client-lib';
import { CompanyChatService } from '../../../company-chat.service';
import { Subscription } from "rxjs";

@Component({
  selector: 'app-company-chat-settings',
  templateUrl: './company-chat-settings.component.html',
  styleUrl: './company-chat-settings.component.scss'
})
export class CompanyChatSettingsComponent implements OnInit, OnDestroy {
  @Input() availableIndexes: IndexAdminModel[] = [];
  @Output() onNewChat = new EventEmitter<void>();

  private subscription: Subscription;
  private _index?: IndexAdminModel;
  get index(): IndexAdminModel {
    return this._index;
  }

  set index(value: IndexAdminModel) {
    this._index = value;
    this.daiseService.daiseIndex = value;
  }

  constructor(
    private daiseService: CompanyChatService,
  ) {
  }

  ngOnInit(): void {
    this._index = this.daiseService.daiseIndex;

    this.subscription = this.daiseService.$indexChange.subscribe(index => {
      this.index = index;
    })
  }

  indexChanged() {
    this.onNewChat.emit();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
